<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-btn
        title="Vis hele landet"
        aria-label="Vis hele landet"
        class="zoom-button"
        v-on="on"
        icon
        @click="resetExtent"
      >
        <img alt="Norge"
          :height="22"
          src="@/assets/img/resetButton.svg"
        />
      </v-btn>
    </template>
    <span>Vis hele landet</span>
  </v-tooltip>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MapResetExtentButton",
  computed: {
    ...mapState(["kart"])
  },
  methods: {
    resetExtent () {
      this.kartview.center = this.kart.mapViewStartupSettings.center;
      this.kartview.zoom = this.kart.mapViewStartupSettings.zoom;
      this.kartview.rotation = 0.0;
    }
  },
  props: {
    kartview: Object
  }
};
</script>

<style></style>